import { City, Option } from "../types";

export const formatCitiesToOption = (cities: City[]): Option[] => {
  return cities.map((city) => ({
    value: city._id,
    label: city.displayName,
  }));
};
